import { persist } from "zustand/middleware";
import useCartStore from "./cart";
import { User } from "../types/item";
import { create } from "zustand";
import APIs from "../apis";

interface AuthState {
  token?: string;
  user?: User;
  setUser: (next?: any) => void;
  refreshUser: () => Promise<any>;
  updateProfile: (profile: any) => Promise<any>;
  logout: () => Promise<void>;
}

const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      token: undefined,
      user: undefined,
      setUser: async (next) => {
        if (!next) {
          set({ user: undefined });
          return;
        }
        const { token, ...user } = next;
        if (token && !Object.keys(user).length) {
          set({ token });
          await get().refreshUser();
          return;
        }
        set(token ? { token, user } : { user });
      },
      refreshUser: async () => {
        if (!get().token) return;
        const user = await APIs.auth.me();
        get().setUser(user);
        return user;
      },
      updateProfile: async (profile) => {
        const user = await APIs.auth.updateProfile(profile);
        get().setUser(user);
        return user;
      },
      logout: async () => {
        try {
          await APIs.auth.logout();
        } catch {}
        set({ token: undefined, user: undefined });
        // useCartStore.getState().reset();
      },
    }),
    {
      name: "auth",
      partialize: (state) => ({ token: state.token }),
    },
  ),
);

export default useAuthStore;
